import { navigate } from 'gatsby'
import { Form, Formik } from 'formik'
import classNames from 'classnames'
import 'react-loading-skeleton/dist/skeleton.css'
import removeSpecialChars from 'rv-utils/build/formatters/removeSpecialChars'
import cpfMask from 'rv-utils/build/masks/cpf'
import cnpjMask from 'rv-utils/build/masks/cnpj'
import If from 'rv-components/react/If'
import Text from 'components/Text'
import Button from 'components/Button'
import ImgStoryblok from 'components/ImgStoryblok'
import { InputText } from 'components/Fields'
import useMediaQuery from 'hooks/useMediaQuery'
import useOriginTheme from 'hooks/useOriginTheme'
import segment from 'utils/segment'
import featureToggle from 'utils/featureToggle'
import './LandingHero.styl'
import storage from 'utils/storage'

const { isSerasaPartner } = featureToggle()

const LandingHero = ({ blok, location }) => {
  const isNotMobile = useMediaQuery('notMobile')
  const { isRecoveryOrigin } = useOriginTheme()

  const renderInputCpfCnpj = () => {
    return (
      <div className="hero-input-container">
        <Formik
          initialValues={{ document: '' }}
          onSubmit={(values) => {
            const documentNumber = values.document
            const leadType =
              documentNumber && removeSpecialChars(documentNumber).length > 11
                ? 'PJ'
                : 'PF'
            storage.session.setItem('leadType', leadType)

            segment.track('document_registration')
            if (typeof window !== 'undefined') {
              window.onbeforeunload = null
            }
            navigate(`/registro`, {
              state: {
                document: values.document,
                source_url: location.href,
              },
            })
          }}
        >
          {({ ...formProps }) => {
            return (
              <Form className="form-content">
                <InputText
                  name="document"
                  placeholder={'Digite seu CPF ou CNPJ'}
                  mask={(e) => {
                    if (e && removeSpecialChars(e).length <= 11) return cpfMask
                    else return cnpjMask
                  }}
                  rules={{ isCpfOrCnpj: true, isRequired: true }}
                  inputMode="numeric"
                  dataTest="input-document"
                  {...formProps}
                />
                {/* <InputText
                    name="document"
                    placeholder="Insira seu CPF"
                    mask={cpfMask}
                    rules={{ isCpf: true, isRequired: true }}
                    inputMode="numeric"
                    {...formProps}
                  /> */}
                <div className="button-container">
                  <Button
                    className="button"
                    type="submit"
                    data-unique="63a2d907-4325-4e21-a45f-d420493b4f10"
                    data-test="button-submit-document"
                  >
                    {blok.button_text}
                  </Button>
                </div>
              </Form>
            )
          }}
        </Formik>
      </div>
    )
  }

  const heroClassnames = classNames('landing-hero', {
    'landing-hero__generalTheme': !isRecoveryOrigin,
  })

  return (
    <div className={heroClassnames}>
      <div className="hero-left-part">
        <Text p size={1} className="label-text description-text">
          {blok.top_text}
        </Text>
        <Text h1 size={3} className="hero-main-text">
          {blok.middle_text}
          <div className="inline blue">{` ${blok.middle_text_blue}`}</div>
        </Text>
        {renderInputCpfCnpj()}
        <If
          condition={isSerasaPartner}
          renderIf={
            <div className="container-serasa-partner">
              <Text p className="container-serasa-partner__text">
                Parceiro
              </Text>
              <ImgStoryblok
                src="https://a.storyblok.com/f/119473/x/2a104df3b3/serasa-logo.svg"
                width={86}
                height={36}
                alt="A Recovery é um parceiro do Serasa"
                preload
              />
            </div>
          }
        />
      </div>
      {isNotMobile && (
        <div className="right-part">
          <ImgStoryblok
            src={blok.image.filename}
            alt={blok.image.alt}
            preload
            dataTest="hero-image"
          />
        </div>
      )}
    </div>
  )
}

export default LandingHero
